import { getAppConfig } from '@/helpers';
import ProductCategoryInterface from '@/interfaces/ProductCategoryInterface';
import axios from 'axios';

class IoProductAPI {
  static getCategories(tree = false): Promise<ProductCategoryInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${getAppConfig('env.API_BASE_PATH')}io-product`, {
        params: {
          endpoint: 'getCategories',
          tree,
        },
      }).then((response) => {
        resolve((response?.data?.data?.categories || []) as ProductCategoryInterface[]);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getBranches() {
    return new Promise((resolve, reject) => {
      axios.get(`${getAppConfig('env.API_BASE_PATH')}io-product`, {
        params: {
          endpoint: 'getBranches',
        },
      }).then((response) => {
        resolve(response.data?.data?.branches || []);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default IoProductAPI;
